/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse
 */
export interface FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse
     */
    Success: boolean;
    /**
     * true — покупка с этим purchase_token зачислена (есть InApp), клиент должен вызвать consumePurchaseAsync.
     * При false покупка остаётся unconsumed для retry при следующей загрузке.
     * @type {boolean}
     * @memberof FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse
     */
    ShouldConsume: boolean;
}

/**
 * Check if a given object implements the FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse(value: object): value is FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse {
    if (!('Success' in value) || value['Success'] === undefined) return false;
    if (!('ShouldConsume' in value) || value['ShouldConsume'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseFromJSON(json: any): FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse {
    return FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Success': json['Success'],
        'ShouldConsume': json['ShouldConsume'],
    };
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseToJSON(json: any): FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse {
    return FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseToJSONTyped(value?: FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Success': value['Success'],
        'ShouldConsume': value['ShouldConsume'],
    };
}

